import { IExportPlugin, LayerType, PluginType } from '@/version-types';
import vectorLayerBehavior from './behavior';
import { VectorLayer } from './domain';

export { VectorLayer } from './domain';
export {
    createDefaultVectorLayerTextInfo,
    createDefaultShadow,
    createDefaultReflection,
    calculateVirtualDistance,
    calculateRealDistance,
} from './utils';
export type { VectorSVGMaterial } from './types';

/**
 * 矢量图层插件
 */
export const vectorLayerPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.LAYER,
    name: LayerType.VECTOR_LAYER,
    createInstance({ identity }) {
        return [{ key: 'VectorLayer', value: new VectorLayer(identity) }];
    },
    createBehavior() {
        return vectorLayerBehavior;
    },
};
